var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasErrors)?_c('div',{staticClass:"bg-red-300 italic rounded"},_vm._l((_vm.errors),function(messages,field){return _c('p',[_vm._v("\n    "+_vm._s(field)+": "+_vm._s(messages.join(','))+"\n  ")])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }